// src/api/service/auth.ts
import axiosInstance from "../axiosInstance";
import { ApiResponse } from "../../types/apiResponse";
import { ServerAuthResponse } from "@/types/auth";

export const getServerToken = async (
  googleToken?: string
): Promise<ApiResponse<ServerAuthResponse>> => {
  if (!googleToken) {
    throw new Error("Google token is required");
  }

  const response = await axiosInstance.post("/auth/token/exchange", {
    token: googleToken,
  });
  return response.data;
};
